// src/components/Sidebar.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import {FaHome,FaYoutube,FaBlog,FaLinkedin,FaNewspaper,FaCalendarAlt,FaChartBar } from 'react-icons/fa';

const navGroups = [
  {
    title: 'Overview',
    items: [
      { path: '/', label: 'Campaign', icon: <FaHome /> },
      { path: '/performance', label: 'Performance', icon: <FaChartBar /> },
      { path: '/schedule', label: 'Schedule', icon: <FaCalendarAlt /> },
    ]
  },
  {
    title: 'Content',
    items: [
      { path: '/youtube', label: 'Youtube', icon: <FaYoutube /> },
      { path: '/linkedin', label: 'LinkedIn', icon: <FaLinkedin /> },
      { path: '/blog', label: 'Blog', icon: <FaBlog /> },
      { path: '/feed', label: 'The Feed', icon: <FaNewspaper /> }
    ]
  }
];

const Sidebar = ({ isOpen, isMobile, closeSidebar }) => {
  const location = useLocation();

  const baseStyle = {
    width: isMobile ? '100vw' : '220px',
    backgroundColor: '#222',
    height: '100vh',
    boxSizing: 'border-box',
    transition: 'left 0.3s ease',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    position: isMobile ? 'fixed' : 'relative',
    top: isMobile ? '64px' : 0,
    left: isMobile ? (isOpen ? '0' : '-100vw') : 0,
    overflowY: 'auto',
    padding: '2rem 1rem'
  };

  const linkStyle = (path) => ({
    color: location.pathname === path ? '#EA7400' : '#fff',
    textDecoration: 'none',
    fontWeight: location.pathname === path ? 'bold' : 'normal',
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    fontSize: isMobile ? '1.1rem' : '1rem',
    padding: '0.75rem 1rem',
    borderRadius: '8px',
    marginBottom: '0.5rem',
    transition: 'background-color 0.2s ease',
    backgroundColor: location.pathname === path ? '#333' : 'transparent'
  });

  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  return (
    <div style={baseStyle}>
      <nav style={{ flexGrow: 1 }}>
    {navGroups.map((group, index) => (
      <div
        key={group.title}
        style={{
          marginBottom: '1.5rem',
          marginTop: isMobile && index === 0 ? '1.6rem' : 0
        }}
      >
      <div style={{ color: '#aaa', fontSize: '0.8rem', marginBottom: '0.5rem', paddingLeft: '1rem', textTransform: 'uppercase' }}>
        {group.title}
      </div>
      {group.items.map((item) => (
        <div key={item.path}>
          <Link
            to={item.path}
            onClick={isMobile ? closeSidebar : undefined}
            style={linkStyle(item.path)}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#333')}
            onMouseLeave={(e) => {
              if (location.pathname !== item.path) e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            <span style={{ fontSize: '1.25rem' }}>{item.icon}</span>
            {item.label}
          </Link>
        </div>
      ))}
    </div>
  ))}
</nav>

      {/* Logout pinned to bottom on mobile */}
      {isMobile && (
  <div style={{ marginTop: 'auto', marginBottom: '165px' }}>
    <button
      onClick={handleLogout}
      style={{
        width: '100%',
        padding: '0.85rem',
        backgroundColor: '#EA7400',
        color: '#fff',
        border: 'none',
        borderRadius: '6px',
        fontSize: '1rem',
        cursor: 'pointer'
      }}
    >
      Logout
    </button>
  </div>
)}
    </div>
  );
};

export default Sidebar;